// extracted by mini-css-extract-plugin
export default {"closeBtn":"ccf-copilot-video-call_closeBtn__TptLf","videoCallCaption":"ccf-copilot-video-call_videoCallCaption__xKNWA"};